import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreItemCategory } from '@flecto/types'
import { Modal, useModal } from '@flecto/ui'

import { CategoryUpdateForm } from '../CategoryUpdateForm/CategoryUpdateForm'

export type ModalCategoryUpdateProps = {
  category?: Partial<CoreItemCategory>
  onSuccess?: (newCategory: CoreItemCategory) => void
}

export function ModalCategoryUpdate({
  category,
  onSuccess,
}: ModalCategoryUpdateProps = {}) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_inventory' })
  const { closeModal } = useModal()
  const [isFormValid, setIsFormValid] = useState(false)
  const [isFormLoading, setIsFormLoading] = useState(false)

  return (
    <Modal size='md'>
      <Modal.Title>
        {category?.id ? category?.name : t('title_new_category')}
      </Modal.Title>
      <Modal.Cancel />
      <Modal.Submit
        disabled={!isFormValid}
        form='category-update-form'
        preventClose
        loading={isFormLoading}
        type='submit'
      >
        {category?.id ? t('modal_save') : t('modal_submit')}
      </Modal.Submit>
      <Modal.Content>
        <CategoryUpdateForm
          category={category}
          onSuccess={(newCat) => {
            onSuccess?.(newCat)
            closeModal()
          }}
          onError={() => closeModal()}
          id='category-update-form'
          onValidationChange={setIsFormValid}
          onLoading={setIsFormLoading}
        />
      </Modal.Content>
    </Modal>
  )
}
